import React from 'react'
import PropTypes from 'prop-types'
// UI
import cn from 'classnames'
import styles from './main.scss'
import Toggle from 'react-toggle'
import translations from '../../translations'

export const CheckedIcon = ({ language }) => {
  return <span className={styles.toggleLabel}>{translations[language].on}</span>
}

export const UncheckedIcon = ({ language }) => {
  return <span className={cn(styles.toggleLabel, styles.dark)}>{translations[language].off}</span>
}

export const IntegrationToggle = ({
  id,
  text,
  onToggle,
  active,
  onExpandClick,
  triangleClass,
  language,
  disabledToggle,
}) => {
  const handleToggle = (event) => {
    onToggle(id, event.target.checked)
  }
  const leftClass = cn(styles.left, { [styles.clickable]: onExpandClick })

  return (
    <div className={styles.top}>
      <div className={leftClass} onClick={onExpandClick}>
        {onExpandClick && <div className={triangleClass} />}
        <span className={styles.title}>{text}</span>
      </div>
      <div className={styles.right}>
        {(onToggle || disabledToggle) && (
          <Toggle
            disabled={disabledToggle}
            onChange={handleToggle}
            checked={active}
            icons={{
              checked: <CheckedIcon language={language} />,
              unchecked: <UncheckedIcon language={language} />,
            }}
          />
        )}
      </div>
    </div>
  )
}

IntegrationToggle.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  onToggle: PropTypes.func,
  active: PropTypes.bool,
  onExpandClick: PropTypes.func,
  triangleClass: PropTypes.string,
  disabledToggle: PropTypes.bool,
  language: PropTypes.oneOf(['en', 'de']).isRequired,
}

IntegrationToggle.defaultProps = {
  language: 'de',
}
